import { ZfCard, ZfCardContent, ZfTypography } from '@zafire/react';
import type { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';

export const EmptyEventCard: FunctionComponent = () => {
    const { t } = useTranslation();

    return (
        <ZfCard style={{ width: '170px', padding: '5px 5px 0 5px' }} orientation="vertical" clickable={false}>
            <ZfCardContent>
                <ZfTypography variant="body-medium" weight="bold">
                    {t('moreEventsInfoText')}
                </ZfTypography>
            </ZfCardContent>
        </ZfCard>
    );
};
